import { useSyncExternalStore } from 'react';
import { authStore, type AuthState } from './authStore';
import { scopeStore } from './scopeStore';
import { onlineStore, type ConnectionState } from './onlineStore';

export function useAuth(): AuthState {
  return useSyncExternalStore(authStore.subscribe, authStore.getState);
}

export function useScope(): [string, (scope: string) => void] {
  const scope = useSyncExternalStore(scopeStore.subscribe, scopeStore.get);
  return [scope, scopeStore.set];
}

export function useOnline(): boolean {
  return useSyncExternalStore(onlineStore.subscribe, onlineStore.get);
}

export function useConnectionState(): ConnectionState {
  return useSyncExternalStore(onlineStore.subscribe, onlineStore.getState);
}
